import { Injectable } from '@angular/core';
import {  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable } from 'rxjs';
import { WebStorage } from '../utility/web.storage';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {

    constructor( private storage: WebStorage ){
    }
    getToken = ()=>{

            return this.storage.get('token');
          
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.getToken()}`,
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
          }
        });
        return next.handle(request);
      }
}